// Calc block input row in the org form fill modal.

import {
  orgFormCalcModeNeedsInput,
  orgFormCalcModeUsesPercentInput,
  parseOrgFormCalcConfig,
} from "@/lib/opportunity/orgFormCalcConfig";
import {
  evaluateOrgFormCalcAmounts,
  formatOrgFormCalcAmount,
  orgFormCalcInputSuffix,
} from "@/lib/opportunity/orgFormCalcEval";
import type { OrgFormFilledBlock } from "@/lib/opportunity/orgFormInstanceTypes";

export function OrgFormCalcBlockFillRow(props: {
  block: OrgFormFilledBlock;
  allBlocks: OrgFormFilledBlock[];
  onCalcChange: (blockId: string, raw: string) => void;
}) {
  const { block, allBlocks, onCalcChange } = props;
  const parsed = parseOrgFormCalcConfig(block.calc_config ?? {});
  const cfg = "error" in parsed ? null : parsed;
  const mode = cfg?.amount_mode ?? "fixed";
  const isTotal = mode === "total";
  const evaluated = isTotal ? evaluateOrgFormCalcAmounts(allBlocks).get(block.id) ?? 0 : null;

  return (
    <div className="block text-xs">
      <span className="font-medium text-gray-700 dark:text-zinc-200">
        {block.label || "Calc line"}
      </span>
      {block.helper_text ? (
        <span className="mt-0.5 block text-gray-500">{block.helper_text}</span>
      ) : null}
      {isTotal ? (
        <p className="mt-1 text-sm font-semibold tabular-nums text-gray-900 dark:text-zinc-100">
          {formatOrgFormCalcAmount(evaluated ?? 0)}
        </p>
      ) : orgFormCalcModeNeedsInput(mode) ? (
        <div className="mt-1 flex items-center gap-2">
          <input
            type="number"
            min={0}
            max={orgFormCalcModeUsesPercentInput(mode) ? 100 : undefined}
            value={String(block.calc_value ?? cfg?.default_amount ?? 0)}
            onChange={(e) => onCalcChange(block.id, e.target.value)}
            className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm dark:border-zinc-700 dark:bg-zinc-800"
          />
          <span className="shrink-0 text-gray-500">{orgFormCalcInputSuffix(mode)}</span>
        </div>
      ) : null}
    </div>
  );
}
